<div class="footer-wrapper flex-shrink-0 a-p-10 text-center">
    <div class="a-footer" [translate]="'footer.text'"></div>
</div>